export enum ExpensesActions {
  Reset = "reset",
  FetchExpenses = "fetchExpenses",
}
